import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { BlurEvent } from '@ckeditor/ckeditor5-angular';

@Directive({
  selector: '[ceInput]',
  standalone: true,
})
export class InputDirective {
  @Output() focused = new EventEmitter<FocusEvent>();
  @Output() blurred = new EventEmitter<BlurEvent>();

  @HostListener('focus', ['$event'])
  onFocus(event: FocusEvent) {
    this.focused.emit(event);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: BlurEvent) {
    this.blurred.emit(event);
  }
}
